import { QuerySwitch } from 'components/QuerySwitch';
import {
  ShiftModalDataContext,
  useShiftModalDataContext,
} from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { FetchAgencyTeamMembersDataProvider } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/FetchAgencyTeamMembers.data.context';
import { SendToAgencyTeamMemberViewPropsProvider } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/SelectAgencyTeamMemberView/SendToAgencyTeamMemberView.props.context';
import { ShiftUnavailableView } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/SelectAgencyTeamMemberView/ShiftUnavailableView.component';
import { FC } from 'react';
import { SelectAgencyTeamMemberViewComponent } from './SelectAgencyTeamMemberView.component';

const Component: FC = () => {
  const { data } = useShiftModalDataContext();
  const order = data?.order;

  return order.canAssign || order.canB2bAssign ? (
    <FetchAgencyTeamMembersDataProvider>
      <SendToAgencyTeamMemberViewPropsProvider>
        <SelectAgencyTeamMemberViewComponent />
      </SendToAgencyTeamMemberViewPropsProvider>
    </FetchAgencyTeamMembersDataProvider>
  ) : (
    <ShiftUnavailableView />
  );
};

export const SelectAgencyTeamMemberView: FC = () => {
  return <QuerySwitch component={Component} context={ShiftModalDataContext} />;
};
